import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddQuestion from "../../../containers/admin/questions-bank/models/add-question";
import BulkImportQuestions from "../../../containers/admin/questions-bank/models/bulk-import-questions";
import SearchBar from "../../../containers/admin/questions-bank/searchbar";
import QuestionsBankTable from "../../../containers/admin/questions-bank/table";
import { getAllQuestionsBankRequest } from "../../../modules/admin-modules/questions-bank/Actions";

const QuestionsBank = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [chapterId, setChapterId] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (chapterId) dispatch(getAllQuestionsBankRequest(chapterId));
  }, [chapterId, dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setChapterId={setChapterId}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <QuestionsBankTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
      <AddQuestion
        key={`qb-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
      <BulkImportQuestions />
    </Layout>
  );
};

export default QuestionsBank;
